// https://github.com/nuxt/framework/issues/6711

export enum SectionComponents {
  SectionContactRecord = 'SectionContact',
  SectionHeroRecord = 'SectionHero',
  SectionLogosListRecord = 'SectionLogos',
  SectionStructuredTextRecord = 'SectionStructuredText',
  SectionLeadRecord = 'SectionLead',
  SectionStatsListRecord = 'SectionStats',
  SectionHeroAboutRecord = 'SectionHeroAbout',
  SectionServiceListRecord = 'SectionServices',
  SectionBigLeadRecord = 'SectionBigLead',
  SectionProjectListRecord = 'SectionProjects',
  SectionLocationListRecord = 'SectionLocations',
  SectionFeaturedProjectsListRecord = 'SectionFeaturedProjects',
  SectionLocationMapRecord = 'SectionLocationMap',
  SectionFeaturedLocationListRecord = 'SectionFeaturedLocations',
  SectionLocationInfoRecord = 'SectionLocationInfo',
  SectionAboutImageRecord = 'SectionAboutImage',
  SectionThumbnailListRecord = 'SectionThumbnails',
  SectionOverviewRecord = 'SectionOverview',
  SectionContentListRecord = 'SectionContentList',
  SectionTitleRecord = 'SectionTitle',
  SectionPushRecord = 'SectionPush',
  SectionAnchorRecord = 'SectionAnchor',
  SectionArticleListRecord = 'SectionArticles'
}
